


















import { Component, Mixins, Prop } from "vue-property-decorator";
import { UnmanagedLoginView } from "../authentication";
import { DocumentViewer } from "./viewers/wizard/guest";

@Component({
  components: {
    UnmanagedLoginView,
    DocumentViewer,
  }
})
export default class GuestWizardDocumentView extends Mixins() {
  @Prop()
  userCode: string;

  @Prop()
  departmentCode: string;

  @Prop()
  hostName: string;

  @Prop()
  patientNo: string;

  @Prop()
  documentId: number;

  @Prop()
  archiveId: number;

  @Prop()
  shouldSelectDepartment: boolean;

  @Prop()
  notification: string;

  @Prop()
  isReadRestrictionAlreadyHandled: boolean;
}
